<template>
  <v-container fluid class="dataset-issue-detail" v-if="issue">
    <v-row class="flex-grow-0">
      <v-btn
        text
        color="primary"
        exact
        :to="{ name: 'rbu-dataset', params: { datasetId: issue.dataset.id } }"
      >
        <h3 class="font-weight-regular">&lt;&lt; {{ issue.dataset.title }}</h3>
      </v-btn>
    </v-row>

    <v-row class="dataset-info-wrapper">
      <!-- <v-btn
        v-if="canShowIgnoreList"
        color="primary"
        small
        class="ml-3"
        @click="goIgnoreList"
        >Ignore List</v-btn
      > -->
      <v-col cols="12">
        <div class="dataset-info">
          <h3>Issue: {{ $parsePeriod(issue.period) }}</h3>
        </div>
      </v-col>
    </v-row>

    <v-row class="flex-grow-1 rounded-b">
      <DatapointList
        :extra-filters="{ issue_id: [$route.params.issueId] }"
      ></DatapointList>
    </v-row>
  </v-container>
</template>
<script>
import { ACTION_TYPES } from "@/store/types";
import { onMounted, ref, computed } from "@vue/composition-api";
import DatasetIssueList from "@/components/dataset/DatasetIssueList.vue";
import DatapointList from "@/components/dataset/DatapointList.vue";
import { USER_TYPE, PERMISSIONS } from "@/constants";
import _ from "lodash";

export default {
  name: "DatasetIssue",
  components: { DatapointList, DatasetIssueList },
  setup(props, { root }) {
    const issue = ref(null);
    const getDatasetIssue = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/issue/",
        params: { issue_id: root.$route.params.issueId },
      });

      if (response.body.success) {
        issue.value = response.body.issue;
      }
    };
    const goIgnoreList = function () {
      root.$router.push({
        name: "rbu-ignore-list",
        params: {
          datasetId: root.$route.params.datasetId,
          issueId: root.$route.params.issueId,
        },
      });
    };

    const canShowIgnoreList = computed(() => {
      if (!root.$store.getters.account) return false;
      return (
        [USER_TYPE.SUPER_ADMIN].includes(root.$store.getters.account.type) ||
        _.some([PERMISSIONS.MANAGE_RBU_DATASET], (p) =>
          root.$store.getters.hasPermission(p)
        )
      );
    });

    onMounted(() => {
      getDatasetIssue();
    });

    return {
      issue,
      goIgnoreList,
      canShowIgnoreList,
    };
  },
};
</script>
